// Configuração da aplicação baseada no app-config.json (carregado em runtime).
// Em k8s o arquivo vem do Secret `planwebui`, montado em /usr/share/nginx/html/config/.
interface ApiConfig {
  baseUrl: string;
}

interface AzureAdConfig {
  clientId: string;
  tenantId: string;
  redirectUri: string;
  scopes: string[];
}

interface AuthConfig {
  azureAd: AzureAdConfig;
}

interface UiConfig {
  itemsPerPage: number;
}

type Environment = 'development' | 'homologation' | 'production';

interface AppConfig {
  environment?: Environment;
  api: ApiConfig;
  auth: AuthConfig;
  ui: UiConfig;
}

let config: AppConfig | null = null;

/**
 * Carrega a configuração do arquivo app-config.json
 * Implementa cache para evitar múltiplas requisições
 */
export const loadConfig = async (): Promise<AppConfig> => {
  if (config) {
    return config;
  }

  try {
    const response = await fetch('/config/app-config.json', { cache: 'no-store' });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const loaded: AppConfig = await response.json();
    config = {
      ...loaded,
      ui: { ...(loaded.ui ?? {}), itemsPerPage: loaded.ui?.itemsPerPage ?? 20 },
    };
    return config;
  } catch (error) {
    console.error('Failed to load config:', error);

    // Fallback para desenvolvimento local (clientId do app registration "Plan Giannotti" —
    // defina em public/config/app-config.json; sem ele o login não funciona).
    config = {
      environment: 'development',
      api: {
        baseUrl: 'http://localhost:8080/api/v1',
      },
      auth: {
        azureAd: {
          clientId: '<definir>',
          tenantId: '134a291a-2d6a-466d-9ef8-28480515db86',
          redirectUri: 'http://localhost:5173/auth/callback',
          scopes: ['api://<definir>/access_as_user'],
        },
      },
      ui: {
        itemsPerPage: 20,
      },
    };

    return config;
  }
};

/**
 * Retorna a configuração carregada (síncronamente)
 * Use apenas após chamar loadConfig()
 */
export const getConfig = (): AppConfig => {
  if (!config) {
    throw new Error('Config not loaded. Call loadConfig() first.');
  }
  return config;
};

export type { AppConfig, ApiConfig, AuthConfig, AzureAdConfig, UiConfig, Environment };
